import { useQuery } from '@tanstack/react-query';
import { ownedParkingPriceRuleOptions } from '../../constants/ownedParkingPriceRules';
export function useOwnedParkingPriceRules(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery(ownedParkingPriceRuleOptions.get(filter, scope));
    return {
        ownedParkingPriceRules: data ?? [],
        loadingOwnedParkingPriceRules: isLoading,
        isSuccess,
    };
}
